import React, { useCallback, useEffect, useState } from "react";
import {
  Row,
  Col,
  Space,
  Button,
  Breadcrumb,
  Form,
  theme,
  Divider,
  Input,
  Select,
  Image,
} from "antd";

import { useParams, useNavigate } from "react-router-dom";
import {
  ArrowLeftOutlined,
  CloudUploadOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Spin } from "antd";
import { useDropzone } from "react-dropzone";
import useCancelModal from "../../../../lib/hooks/useCancelModal";
import { routes } from "../../../../routes";
import Heading from "../../../../components/common/heading";
import WithSidebar from "../../../../templates/withSidebar";
import SuccessModal from "../../../../components/modal/successModal";
import FailModal from "../../../../components/modal/failModal";
import { downloadFile } from "../../../../services/uploadFile";
import {
  getListDepartments,
  getListDivisions,
  updateProjectData,
  getListProjectByYear,
  uploadFile,
} from "../../../../services/progressPerformance";
import { SUCCESS_CODE, ERR_0022 } from "../../../../lib/const";

const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  padding: "20px",
  marginBottom: "20px",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#eeeeee",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  outline: "none",
  transition: "border .24s ease-in-out",
};

const baseStyleHover = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  padding: "20px",
  marginBottom: "20px",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#2E90FA",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  outline: "none",
  transition: "border .24s ease-in-out",
};

const { useToken } = theme;
const { Option } = Select;

export const EditProject = () => {
  const navigate = useNavigate();
  const { token } = useToken();
  const params = useParams();
  const [form] = Form.useForm();
  const { setOpenCancelModal, setPreviousPage } = useCancelModal();
  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);
  const [isHover, setIsHover] = useState(false);
  const [data, setData] = useState({});
  const [dropDownDepartment, setDropDownDepartment] = useState([]);
  const [dropDownDivision, setDropDownDivision] = useState([]);
  const [departmentId, setDepartmentId] = useState();
  const [divisionId, setDivisionId] = useState();
  const [errorMessage, setErrorMessage] = useState("");
  const [failSubtitle, setFailSubtitle] = useState("");
  const [filePath, setFilePath] = useState("");
  const [fileName, setFileName] = useState("");
  const [imageSrc, setImageSrc] = useState("");
  const [uploading, setUploading] = useState(false);

  const handleMouseEnter = () => {
    setIsHover(true);
  };
  const handleMouseLeave = () => {
    setIsHover(false);
  };

  const onDrop = async (acceptedFiles) => {
    setUploading(true);
    if (acceptedFiles[0] === undefined) {
      setFailModal(true);
      setErrorMessage("อัปโหลดไฟล์ไม่สำเร็จ");
      setFailSubtitle("อัปโหลดเกิน 1 ไฟล์");
      setUploading(false);
    } else if (acceptedFiles[0].size > 2000000) {
      setFailModal(true);
      setErrorMessage("อัปโหลดไฟล์ไม่สำเร็จ");
      setFailSubtitle("ขนาดไฟล์เกิน 2 MB");
      setUploading(false);
    } else {
      let formData = new FormData();
      formData.append("file", acceptedFiles[0]);

      const res = await uploadFile(formData);

      if (res.data.code === "0000") {
        const { objectValue } = res.data;
        setFilePath(objectValue.filePath);
        setFileName(objectValue.fileName);

        if (objectValue.filePath) {
          const res = await downloadFile(objectValue.filePath);

          if (res.data.code === SUCCESS_CODE) {
            const { objectValue } = res.data;

            form.setFieldsValue({
              imageName: objectValue.fileName,
              imagePath: objectValue.filePath,
              image: objectValue.bytes,
            });
            const href = `${"data:image/jpeg;base64," + objectValue.bytes}`;
            setImageSrc(href);
            setUploading(false);
          } else {
            setFailModal(true);
            setErrorMessage("อัปโหลดไฟล์ไม่สำเร็จ");
            setFailSubtitle("");
            setUploading(false);
          }
        } else {
          setFailModal(true);
          setErrorMessage("อัปโหลดไฟล์ไม่สำเร็จ");
          setFailSubtitle("");
          setUploading(false);
        }
      } else {
        setFailModal(true);
        setErrorMessage("อัปโหลดไฟล์ไม่สำเร็จ");
        setFailSubtitle("");
        setUploading(false);
      }
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: false,
    accept: {
      "image/jpeg": [],
      "image/png": [],
    },
  });

  const handleChange = (value) => {
    setDepartmentId(value);
    form.setFields([
      {
        name: "divisionId",
        value: undefined,
      },
      {
        name: "indicatorId",
        value: undefined,
      },
    ]);
  };

  const onFinish = async (values) => {
    const request = {
      yearOfBudget: params.year,
      projectId: form.getFieldValue().projectId, // params.id,
      projectNameEn: form.getFieldValue().projectNameEn,
      projectNameTh: values.projectNameTh,
      departmentId: values.departmentId,
      divisionId: form.getFieldValue().divisionId,
      staffName: values.staffName,
      staffTelephone: values.staffTelephone,
      staffEmail: values.staffEmail,
      imageName: fileName,
      imagePath: filePath,
    };

    const res = await updateProjectData(form.getFieldValue().id, request);

    if (res.data.code === SUCCESS_CODE) {
      setSuccessModal(true);
      setTimeout(() => {
        navigate(routes.progress_tab_kpi);
        setSuccessModal(false);
      }, 2000);
    } else {
      if (res.data.code === ERR_0022) {
        setFailModal(true);
        setErrorMessage("โครงการดังกล่าวมีอยู่ในระบบเรียบร้อยแล้ว");
      } else {
        setErrorMessage("");
        setFailModal(true);
        setTimeout(() => {
          setFailModal(false);
        }, 2000);
      }
    }
  };

  const fetchProjectById = useCallback(
    async (id) => {
      const res = await getListProjectByYear({
        year: params.year,
        projectId: id,
      });

      if (res.data.code === SUCCESS_CODE) {
        const { objectValue } = res.data;

        setData(objectValue[0]);
        setDepartmentId(objectValue[0]?.departmentId);

        if (objectValue[0]?.imagePath) {
          const res = await downloadFile(objectValue[0]?.imagePath);

          if (res.data.code === SUCCESS_CODE) {
            const { objectValue } = res.data;

            form.setFieldsValue({
              imageName: objectValue.fileName,
              imagePath: objectValue.filePath,
              image: objectValue.bytes,
            });
            const href = `${"data:image/jpeg;base64," + objectValue.bytes}`;
            setImageSrc(href);
          }
        }

        form.setFieldsValue({
          id: objectValue[0]?.id,
          yearOfBudget: objectValue[0]?.yearOfBudget,
          projectId: objectValue[0]?.projectId,
          projectNameEn: objectValue[0]?.projectNameEn,
          projectNameTh: objectValue[0]?.projectNameTh,
          departmentId: objectValue[0]?.departmentId,
          departmentNameTh: objectValue[0]?.departmentNameTh,
          departmentNameEn: objectValue[0]?.departmentNameEn,
          divisionId: objectValue[0]?.divisionId,
          divisionNameTh: objectValue[0]?.divisionNameTh,
          divisionNameEn: objectValue[0]?.divisionNameEn,
          staffName: objectValue[0]?.staffName,
          staffEmail: objectValue[0]?.staffEmail,
          staffTelephone: objectValue[0]?.staffTelephone,
          imageName: objectValue[0]?.imageName,
          imagePath: objectValue[0]?.imagePath,
        });
      }
    },
    [setData]
  );

  const fetchListDepartments = useCallback(async () => {
    try {
      const res = await getListDepartments();

      if (res.data.code === SUCCESS_CODE) {
        let result_data = res.data.objectValue;
        setDropDownDepartment(result_data);
      }
    } catch (error) {}
  }, [dropDownDepartment]);

  const fetchListDivisions = useCallback(async () => {
    try {
      const res = await getListDivisions(departmentId);

      if (res.data.code === SUCCESS_CODE) {
        let result_data = res.data.objectValue;
        setDropDownDivision(result_data);
      }
    } catch (error) {}
  }, [departmentId]);

  useEffect(() => {
    fetchListDepartments();
  }, []);

  useEffect(() => {
    if (departmentId) {
      fetchListDivisions();
    }
  }, [departmentId]);

  useEffect(() => {
    fetchProjectById(params.id);
  }, [params.id, fetchProjectById]);

  return (
    <WithSidebar>
      <div>
        <Row gutter={[24, 24]} style={{ marginTop: 15 }}>
          <Col span={24}>
            <div className="flex items-center">
              <Space size={12}>
                <Button
                  type="link"
                  onClick={() => {
                    setOpenCancelModal(true);
                    setPreviousPage(routes.progress_tab_kpi);
                  }}
                  style={{ padding: 0 }}
                >
                  <ArrowLeftOutlined style={{ color: "#000", fontSize: 16 }} />
                </Button>
                <Heading text={"แก้ไขโครงการ"} size={4} style={{ margin: 0 }} />
              </Space>
            </div>
            <Breadcrumb
              style={{ paddingTop: 10 }}
              items={[
                {
                  title: "กำหนดโครงการ",
                },
                {
                  title: "รายละเอียด",
                },
                {
                  title: <span className="pr_green">แก้ไขโครงการ</span>,
                },
              ]}
            />
          </Col>

          <Col span={24}>
            <Form
              form={form}
              onFinish={onFinish}
              layout="vertical"
              autoComplete="off"
              style={{ width: "100%", padding: "0 30px" }}
            >
              <Row gutter={[24, 16]} style={{ marginBottom: 10 }}>
                <Col span={24} align="right">
                  <Space>
                    <Button
                      onClick={() => {
                        setOpenCancelModal(true);
                        setPreviousPage(routes.progress_tab_kpi);
                      }}
                    >
                      ยกเลิก
                    </Button>
                    <Button type="primary" htmlType="submit">
                      บันทึก
                    </Button>
                  </Space>
                </Col>
              </Row>

              <Row gutter={[16, 8]} className="card">
                <Col span={24}>
                  <Row gutter={16}>
                    <Col span={18}>
                      <Heading
                        text={`ปีงบประมาณ${" " + params.year}`}
                        size={4}
                        style={{ margin: 0, color: token.thPrimary }}
                      />
                    </Col>
                  </Row>
                  <Divider />
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="ชื่อโครงการ"
                    name={"projectNameTh"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Input placeholder="ชื่อโครงการ" />
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="ฝ่าย"
                    name={"departmentId"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Select
                      allowClear
                      style={{
                        width: "100%",
                      }}
                      placeholder="กรุณาเลือก"
                      onChange={handleChange}
                    >
                      {dropDownDepartment.map((option) => (
                        <Option value={option.departmentId}>
                          {option.departmentNameTh}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={16} className="gutter-row">
                  <Form.Item
                    label="กอง"
                    name={"divisionId"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Select
                      allowClear
                      style={{
                        width: "100%",
                      }}
                      placeholder="กรุณาเลือก"
                      onChange={(e) => {
                        setDivisionId(e);
                        form.setFields([
                          {
                            name: "indicatorId",
                            value: undefined,
                          },
                        ]);
                      }}
                    >
                      {dropDownDivision.map((item) => (
                        <Option value={item.divisionId}>
                          {item.divisionNameTh}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="ชื่อ-นามสกุล ผู้รับผิดชอบโครงการ"
                    name={"staffName"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Input placeholder="ชื่อ-นามสกุล ผู้รับผิดชอบโครงการ" />
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="อีเมล์"
                    name={"staffEmail"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Input placeholder="อีเมล์" />
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="เบอร์โทรศัพท์"
                    name={"staffTelephone"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Input placeholder="เบอร์โทรศัพท์" />
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="รูป"
                    name={"image"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดอัปโหลดไฟล์"
                      }
                    ]}
                    style={{ textAlign: "center" }}
                  >
                    <Space direction="vertical" size={12}>
                      {imageSrc && (
                        <Image
                          src={imageSrc}
                          width={200}
                          height={"auto"}
                          alt="imageSrc"
                          style={{ marginBottom: "10px" }}
                        />
                      )}
                      <section style={{ display: "contents" }}>
                        <div
                          {...getRootProps()}
                          style={isHover ? baseStyleHover : baseStyle}
                          onMouseEnter={handleMouseEnter}
                          onMouseLeave={handleMouseLeave}
                        >
                          <input {...getInputProps()} />

                          {uploading ? (
                            <p className="ant-upload-drag-icon">
                              <Spin
                                indicator={<LoadingOutlined spin />}
                                size="large"
                              />
                            </p>
                          ) : (
                            <p className="ant-upload-drag-icon">
                              <CloudUploadOutlined
                                style={{ color: "#1677ff", fontSize: 52 }}
                              />
                            </p>
                          )}
                          <p
                            className="ant-upload-text"
                            style={{ fontWeight: 600 }}
                          >
                            Drag & drop files or{" "}
                            <span style={{ color: "#2E90FA" }}>Browse</span>
                          </p>
                          <p className="ant-upload-hint">
                            สามารถอัปโหลดครั้งละ 1 ไฟล์ รองรับนามสกุล .png .jpeg
                            เท่านั้น ขนาดไม่เกิน 2 MB
                          </p>
                        </div>
                      </section>
                    </Space>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </div>

      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        title={"สำเร็จ"}
        subTitle={"ทำรายการสำเร็จ"}
      />
      <FailModal
        title={errorMessage ? errorMessage : ""}
        subTitle={
          failSubtitle
            ? failSubtitle
            : errorMessage
            ? "กรุณาทำการตรวจสอบข้อมูล"
            : ""
        }
        open={failModal}
        setOpen={setFailModal}
        setErrMsg={setErrorMessage}
      />
    </WithSidebar>
  );
};
